import script from "./InteractiveMessagePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./InteractiveMessagePreview.vue?vue&type=script&lang=ts&setup=true"

import "./InteractiveMessagePreview.vue?vue&type=style&index=0&id=c496d2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c496d2a6"]])

export default __exports__